import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ButtonProps, shapes } from './shapes';
export type RequirePicked<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;
export type ButtonBuilderOptions<T extends BaseShareActionArgs> = {
  ariaLabel?: string;
  buttonLabel?: string;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: React.FC<any>;
  action: (args: T) => void;
};
export type ButtonShapes = keyof typeof shapes;
export type ButtonWithContentProps = {
  shape: Exclude<ButtonShapes, 'square' | 'round'>;
} & RequirePicked<ButtonProps, 'content'>;
export type ButtonWithoutContentProps = {
  shape: Extract<ButtonShapes, 'square' | 'round'>;
} & ButtonProps;
export type ShareButtonProps = {
  beforeOnClick?: (event: React.MouseEvent) => void;
} & (ButtonWithoutContentProps | ButtonWithContentProps);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BaseShareActionArgs = {
  shareUrl: string;
  utmParams?: Record<string, any>;
  teaser?: string;
};
export const buildShareButtonComponent = <T extends BaseShareActionArgs,>({
  action,
  ariaLabel,
  buttonLabel,
  className,
  icon
}: ButtonBuilderOptions<T>) => {
  const ShareButton = props => {
    const $ = _c(9);
    const Shape = shapes[props.shape];
    let t0;
    if ($[0] !== props) {
      t0 = event => {
        event.preventDefault();
        props.beforeOnClick?.(event);
        action(props);
      };
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    const handleClick = t0;
    const t1 = props.className || "";
    const t2 = props.title || "";
    let t3;
    if ($[2] !== Shape || $[3] !== handleClick || $[4] !== props.boxShadow || $[5] !== props.content || $[6] !== t1 || $[7] !== t2) {
      t3 = <Shape aria-label={ariaLabel} boxShadow={props.boxShadow} className={t1} buttonClassName={className} href="#" onClick={handleClick} role="button" title={t2} label={buttonLabel || ariaLabel} icon={icon} content={props.content} />;
      $[2] = Shape;
      $[3] = handleClick;
      $[4] = props.boxShadow;
      $[5] = props.content;
      $[6] = t1;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  };
  return ShareButton;
};